import { logger } from '@vagabondinternet/logging';
import { type DictionaryModule, loadDictionary } from '@words-happen/dictionary';
import { useEffect, useState } from 'react';

/** Where the word list is: still downloading, ready to look words up, or failed to arrive. */
export type DictionaryState =
  | { status: 'loading' }
  | { status: 'ready'; dictionary: DictionaryModule }
  | { status: 'failed' };

/**
 * Fetches the word list, a chunk of its own, the first time a game screen mounts. The module is cached, so
 * the next screen gets it at once. `load` is for tests.
 */
export const useDictionary = (load: () => Promise<DictionaryModule> = loadDictionary): DictionaryState => {
  const [state, setState] = useState<DictionaryState>({ status: 'loading' });

  useEffect(() => {
    let mounted = true;
    load()
      .then((dictionary) => {
        if (mounted) setState({ status: 'ready', dictionary });
      })
      .catch((error: unknown) => {
        logger.error({ message: 'Failed to load the dictionary', error });
        if (mounted) setState({ status: 'failed' });
      });
    return () => {
      mounted = false;
    };
  }, [load]);

  return state;
};
